export default {
  buttons: {
    sign_in: 'Zaloguj się',
    sign_up: 'Zarejestruj się',
    logout: 'Wyloguj się',
  },
  logout_confirm: {
    title: 'Wylogować się?',
    description: 'Czy na pewno chcesz się wylogować?',
    cancel: 'Anuluj',
    confirm: 'Wyloguj się',
  },
};
